import { CustomerAdsFiltersProps } from '../../types';
import CustomerAdsFiltersView from './CustomerAdsFilters.View';

const CustomerAdsFilters = (props: CustomerAdsFiltersProps) => (
  <CustomerAdsFiltersView {...props} />
);

export default CustomerAdsFilters;
